import { DataGridContextProvider } from '@cmg/data-grid';
import { Box } from '@cmg/design-system';
import type { FC } from 'react';

import type { CalendarGridProps } from '../calendar-grid/CalendarGrid';
import { CalendarGrid } from '../calendar-grid/CalendarGrid';
import type { TabValue } from './CalendarTabs.model';

export type CalendarTabPanelProps = Readonly<{
  tab: TabValue;
  isActive: boolean;
  gridProps: CalendarGridProps;
}>;
export const CalendarTabPanel: FC<CalendarTabPanelProps> = ({ tab, isActive, gridProps }) => {
  return (
    <Box
      px={3}
      pb={1}
      flex={1}
      role="tabpanel"
      hidden={!isActive}
      id={`${tab}-calendar-tabpanel`}
      aria-labelledby={`${tab}-calendar-tab`}
    >
      {isActive && (
        <DataGridContextProvider>
          <CalendarGrid {...gridProps} />
        </DataGridContextProvider>
      )}
    </Box>
  );
};
